import { Rule } from "@shared/types";

import { authDelete } from "../auth";

export const deleteOrgPrivateRule = (ruleHashid: string) =>
  authDelete<Rule>(`/api/registry/rules/${ruleHashid}`);
